export const layout = {
  heading: { MOBILE: "8vw", TABL: "4vw", TABP: "8vw", PC: "4vw" },
  heading2: { MOBILE: "5.5vw", TABL: "2.5vw", TABP: "5.5vw", PC: "2.5vw" },
  subheading: { MOBILE: "5vw", TABL: "2vw", TABP: "4vw", PC: "2vw" },
  subheading2: { MOBILE: "3.5vw", TABL: "1.5vw", TABP: "3.5vw", PC: "1.5vw" },
  textMedium: { MOBILE: "3.5vw", TABL: "1.25vw", TABP: "3.5vw", PC: "1.25vw" },
  textSmall: { MOBILE: "3vw", TABL: "1vw", TABP: "2vw", PC: "1vw" },
  textLarge: { MOBILE: "", TABL: "", TABP: "", PC: "" },
  lineHeightSmall: { MOBILE: "2vw", TABL: "1vw", TABP: "2vw", PC: "1vw" },
  accordiaonBox: {
    height: { MOBILE: "100px", TABL: "50px", TABP: "100px", PC: "50px" },
  },
  spacingSmall: { MOBILE: "", TABL: "", TABP: "", PC: "" },
  spacingMedium: { MOBILE: "", TABL: "", TABP: "", PC: "" },
  spacingLarge: { MOBILE: "", TABL: "", TABP: "", PC: "" },
  dashboardBox1: {
    height: { MOBILE: "90vw", TABL: "50vh", TABP: "90vw", PC: "50vh" },
    width: { MOBILE: "90vw", TABL: "50vh", TABP: "90vw", PC: "50vh" },
    marginLeft: { MOBILE: "0px", TABL: "0px", TABP: "0px", PC: "0px" },
    marginRight: { MOBILE: "0px", TABL: "25px", TABP: "0px", PC: "25px" },
    marginTop: { MOBILE: "50px", TABL: "0px", TABP: "50px", PC: "0px" },
    justifyContent: {
      MOBILE: "center",
      TABL: "flex-end",
      TABP: "center",
      PC: "flex-end",
    },
  },
  dashboardBox2: {
    height: { MOBILE: "90vw", TABL: "50vh", TABP: "90vw", PC: "50vh" },
    width: { MOBILE: "90vw", TABL: "50vh", TABP: "90vw", PC: "50vh" },
    marginLeft: { MOBILE: "0px", TABL: "0px", TABP: "0px", PC: "0px" },
    marginRight: { MOBILE: "0px", TABL: "25px", TABP: "0px", PC: "25px" },
    marginTop: { MOBILE: "50px", TABL: "50px", TABP: "50px", PC: "50px" },
    justifyContent: {
      MOBILE: "center",
      TABL: "flex-start",
      TABP: "center",
      PC: "flex-start",
    },
  },
};
